var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomHttpHeader = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 70,
  height: 40,
  viewBox: "0 0 70 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 15.5,
  width: 12,
  height: 13,
  rx: 1.5,
  stroke: "currentColor",
  fill: "none"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.3892 11.6825C41.7929 11.3056 42.4257 11.3272 42.8026 11.7309L44.1676 13.1926C44.5446 13.5963 44.5229 14.2291 44.1192 14.606L43.3884 15.2885L40.6584 12.365L41.3892 11.6825ZM39.9275 13.0475L42.6575 15.971L34.6178 23.4786L31.8878 20.5551L39.9275 13.0475ZM31.3294 21.0764L31.1569 21.2376L31.1762 21.2582C31.135 21.3208 31.1009 21.3881 31.0746 21.4588L29.8075 24.8669C29.7213 25.0987 29.9367 25.3293 30.1737 25.2592L33.6605 24.228C33.7329 24.2066 33.8023 24.1772 33.8676 24.1404L33.8869 24.1611L34.0594 24C34.0011 24.0544 33.9367 24.1015 33.8676 24.1404L31.1762 21.2582C31.2197 21.192 31.2711 21.1309 31.3294 21.0764Z",
  fill: "currentColor"
})));
export default SvgCustomHttpHeader;